
$(document).ready(function () {
    
    function addDays(date, amount) {
        var tzOff = date.getTimezoneOffset() * 60 * 1000,
            t = date.getTime(),
            d = new Date(),
            tzOff2;
      
        t += (1000 * 60 * 60 * 24) * amount;
        d.setTime(t);
      
        tzOff2 = d.getTimezoneOffset() * 60 * 1000;
        if (tzOff != tzOff2) {
          var diff = tzOff2 - tzOff;
          t += diff;
          d.setTime(t);
        }
      
        return d;
    }
    
    /**
     * Calendar's localization
     */
    let calendarLocalization = {
        uk: {
            days: ['Недія','Понеділок','Вівторок','Середа','Четвер','Пятниця','Субота'],
            daysShort: ['Нед','Пон','Вів','Сер','Чет','Пят','Суб'],
            daysMin: ['Нд','Пн','Вт','Ср','Чт','Пт','Сб'],
            months: ['Січень','Лютий','Березень','Квітень','Травень','Червень','Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'],
            monthsShort: ['Січ','Лют','Берез','Квіт','Трав','Черв','Лип','Серп','Верес','Жовт','Листоп','Груд'],
            today: 'Сьогодні',
            clear: 'Очистити',
            dateFormat: 'dd.mm.yyyy',
            timeFormat: 'hh:ii',
            firstDay: 1
        },
        ru: {
            days: ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
            daysShort: ['Вос','Пон','Вто','Сре','Чет','Пят','Суб'],
            daysMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
            months: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            monthsShort: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
            today: 'Сегодня',
            clear: 'Очистить',
            dateFormat: 'dd.mm.yyyy',
            timeFormat: 'hh:ii',
            firstDay: 1
        }
    }

    let theLanguage = $('html').attr('lang');
    $.fn.datepicker.language['ru'] = calendarLocalization[theLanguage];

    
    let datepicker1, datepicker2, datepicker3, datepicker4, dateTo, dateTo1, 
    dt1 = $('#datepicker-from11'),
    dt2 = $('#datepicker-to11'),
    dt1_1 = $('#datepicker-from22'),
    dt2_1 = $('#datepicker-to22'),
    dt3 = $('.datepicker-from1'), 
    dt4 = $('.datepicker-to1'), 
    dt5 = $('.datepicker-from2'), 
    dt6 = $('.datepicker-to2'),
    dt7 = $('.datepicker-article');

    datepicker1 = dt1.datepicker({
        maxDate: new Date(),
        onSelect: function (fd, d, picker) {
            dateTo = $('.datepicker-to').val(); 
            datepicker2.update('minDate', new Date(d));
            if(dateTo.length) {
                if(d > new Date(dateTo.split(".")[2], parseInt(dateTo.split(".")[1]) - 1, dateTo.split(".")[0])) {

                    if(d.setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) {
                        datepicker2.selectDate(d);
                    } else {
                        datepicker2.selectDate(addDays(d, 1));
                    }
                }
            }

            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');
    datepicker1_1 = dt1_1.datepicker({
        maxDate: new Date(),
        onSelect: function (fd, d, picker) {
            dateTo = $('.datepicker-to').val();
            datepicker2_1.update('minDate', new Date(d));
            if(dateTo.length) {
                if(d > new Date(dateTo.split(".")[2], parseInt(dateTo.split(".")[1]) - 1, dateTo.split(".")[0])) {

                    if(d.setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) {
                        datepicker2_1.selectDate(d);
                    } else {
                        datepicker2_1.selectDate(addDays(d, 1));
                    }
                }
            }

            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');

    datepicker2 = dt2.datepicker({
        maxDate: new Date(),
        onSelect: function (fd, d, picker) {
            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');
    datepicker2_1 = dt2_1.datepicker({
        maxDate: new Date(),
        onSelect: function (fd, d, picker) {
            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');

    if(dt1 && dt1.attr('value').length){
        datepicker1.selectDate(new Date(dt1.attr('value').split(".")[2], parseInt(dt1.attr('value').split(".")[1]) - 1, dt1.attr('value').split(".")[0]));
    }
    if(dt2 && dt2.attr('value').length){
        datepicker2.selectDate(new Date(dt2.attr('value').split(".")[2], parseInt(dt2.attr('value').split(".")[1]) - 1, dt2.attr('value').split(".")[0]));
    }
    if(dt1_1 && dt1_1.attr('value').length){
        datepicker1_1.selectDate(new Date(dt1.attr('value').split(".")[2], parseInt(dt1_1.attr('value').split(".")[1]) - 1, dt1_1.attr('value').split(".")[0]));
    }
    if(dt2_1 && dt2_1.attr('value').length){
        datepicker2_1.selectDate(new Date(dt2.attr('value').split(".")[2], parseInt(dt2_1.attr('value').split(".")[1]) - 1, dt2_1.attr('value').split(".")[0]));
    }

    datepicker3 = dt3.datepicker({
        minDate: new Date(),
        onSelect: function (fd, d, picker) {
            dateTo1 = $('.datepicker-to1').val(); 
            datepicker4.update('minDate', new Date(d));
            if(dateTo1.length) {
                if(d > new Date(dateTo1.split(".")[2], parseInt(dateTo1.split(".")[1]) - 1, dateTo1.split(".")[0])) {

                    if(d.setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) {
                        datepicker4.selectDate(d);
                    } else {
                        datepicker4.selectDate(addDays(d, 1));
                    }
                }
            }

            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');

    datepicker4 = dt4.datepicker({
        minDate: new Date(),
        onSelect: function (fd, d, picker) {
            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');

    datepicker5 = dt5.datepicker({
        minDate: new Date(),
        onSelect: function (fd, d, picker) {
            dateTo1 = $('.datepicker-to2').val(); 
            datepicker6.update('minDate', new Date(d));
            if(dateTo1.length) {
                if(d > new Date(dateTo1.split(".")[2], parseInt(dateTo1.split(".")[1]) - 1, dateTo1.split(".")[0])) {

                    if(d.setHours(0,0,0,0) === new Date().setHours(0,0,0,0)) {
                        datepicker6.selectDate(d);
                    } else {
                        datepicker6.selectDate(addDays(d, 1));
                    }
                }
            }

            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');

    datepicker6 = dt6.datepicker({
        minDate: new Date(),
        onSelect: function (fd, d, picker) {
            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker'); 

    datepicker7 = dt7.datepicker({
        minDate: new Date(),
        onSelect: function (fd, d, picker) {
            if (d.getDate() != '') {
                picker.hide();
            }
        }
    }).data('datepicker');

    if(dt3 && dt3.attr('value')){
        datepicker3.selectDate(new Date(dt3.attr('value').split(".")[2], parseInt(dt3.attr('value').split(".")[1]) - 1, dt3.attr('value').split(".")[0]));
    }
    if(dt4 && dt4.attr('value')){
        datepicker4.selectDate(new Date(dt4.attr('value').split(".")[2], parseInt(dt4.attr('value').split(".")[1]) - 1, dt4.attr('value').split(".")[0]));
    }
    if(dt5 && dt5.attr('value')){
        datepicker5.selectDate(new Date(dt5.attr('value').split(".")[2], parseInt(dt5.attr('value').split(".")[1]) - 1, dt5.attr('value').split(".")[0]));
    }
    if(dt6 && dt6.attr('value')){
        datepicker6.selectDate(new Date(dt6.attr('value').split(".")[2], parseInt(dt6.attr('value').split(".")[1]) - 1, dt6.attr('value').split(".")[0]));
    }
    if(dt7 && dt7.attr('value')){
        datepicker7.selectDate(new Date(dt7.attr('value').split(".")[2], parseInt(dt7.attr('value').split(".")[1]) - 1, dt7.attr('value').split(".")[0]));
    }
});